import { useEffect } from 'react';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTextProcessStatus,
  getTargetLiveText,
  inspection,
  getUserPreferences,
  getInspectionSettings,
  getDocumentsState,
  getIsSingleFile,
  getIsSpelling,
} from 'store';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import DictionarySelect from 'components/DictionarySelect';
import { DocumentStates } from 'types';
import { Dictionaries } from '@verify/shared-utils';
import { useNoLiveTextAlert } from './NoLiveTextAlert';
import { Info } from '@globalvisioninc/assets/icons';
import styles from './DictionarySettings.module.scss';

const DictionarySettings = () => {
  const dispatch = useDispatch();
  const documentProcessed = useSelector(getTextProcessStatus);
  const targetLiveText = useSelector(getTargetLiveText);
  const userPrefs = useSelector(getUserPreferences);
  const inspectionSettings = useSelector(getInspectionSettings);
  const isSpelling = useSelector(getIsSpelling);
  const documentsState = useSelector(getDocumentsState);
  const isSingleFile = useSelector(getIsSingleFile);
  const bothDocumentsLoaded =
    (!isSingleFile &&
      documentsState.source === DocumentStates.LOADED &&
      documentsState.target === DocumentStates.LOADED) ||
    (isSingleFile && documentsState.target === DocumentStates.LOADED);
  const isValidDictionary = !!(inspectionSettings.dictionaryName && inspectionSettings.dictionaryName.length > 0);

  useEffect(() => {
    if (isSpelling && (!inspectionSettings.dictionaryName || inspectionSettings.dictionaryName.length === 0)) {
      dispatch(
        inspection.actions.setInspectionSettings({
          dictionaryName:
            userPrefs.lastDictionary && userPrefs.lastDictionary.length > 0
              ? userPrefs.lastDictionary
              : Dictionaries.English_USA,
        }),
      );
    }
  }, [isSpelling, inspectionSettings.dictionaryName]);

  const toggleSpellCheck = () => {
    if (isSpelling) {
      // turn off spelling
      dispatch(inspection.actions.setInspectionSettings({ spelling: false, dictionaryName: undefined }));
    } else {
      // turn on spelling
      dispatch(
        inspection.actions.setInspectionSettings({
          spelling: true,
          dictionaryName: isValidDictionary
            ? inspectionSettings.dictionaryName
            : userPrefs.lastDictionary && userPrefs.lastDictionary.length > 0
              ? userPrefs.lastDictionary
              : Dictionaries.English_USA,
        }),
      );
    }
  };
  const isSpellCheckDisabled = !documentProcessed || !targetLiveText;
  const alertText = useNoLiveTextAlert({ disabled: isSpellCheckDisabled });

  return (
    <div className={styles.root}>
      <div className={styles.checkbox}>
        <GVCheckbox
          checked={isSpelling}
          onChange={toggleSpellCheck}
          label="Spell Check"
          data-testid="spellcheck_enable"
          disabled={isSpellCheckDisabled}
        />
        {isSpellCheckDisabled && bothDocumentsLoaded && (
          <GVTooltip title={alertText} arrow side="bottom" className={styles.tooltip}>
            <Info className={styles.icon} data-testid="spell_check_info_icon" />
          </GVTooltip>
        )}
      </div>

      {documentProcessed && isSpelling && <DictionarySelect />}
    </div>
  );
};

export default DictionarySettings;
